/* Keep all HD source candidates; request cards near the visible viewport. */
(function(){
 'use strict';
 function load(img){
  var poster=img.getAttribute('data-ezspa-home-poster');if(poster){img.setAttribute('poster',poster);img.removeAttribute('data-ezspa-home-poster');return;}
  var src=img.getAttribute('data-ezspa-home-src');if(!src)return;
  img.decoding='async';img.loading='eager';img.fetchPriority='low';
  var set=img.getAttribute('data-ezspa-home-srcset');if(set)img.setAttribute('srcset',set);
  img.setAttribute('src',src);img.removeAttribute('data-ezspa-home-src');img.removeAttribute('data-ezspa-home-srcset');
 }
 var observer='IntersectionObserver' in window?new IntersectionObserver(function(entries){
  entries.forEach(function(entry){if(entry.isIntersecting){load(entry.target);observer.unobserve(entry.target);}});
 },{rootMargin:'150px 0px'}):null;
 function scan(root){root.querySelectorAll('img[data-ezspa-home-src],video[data-ezspa-home-poster]').forEach(function(img){if(observer)observer.observe(img);else load(img);});}
 scan(document);document.addEventListener('shopify:section:load',function(event){scan(event.target);});
})();
